/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Skill_Groups_Is_ActiveInputs */

const en_tables_skill_groups_is_active = /** @type {(inputs: Tables_Skill_Groups_Is_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active`)
};

const de_tables_skill_groups_is_active = /** @type {(inputs: Tables_Skill_Groups_Is_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist aktiv`)
};

/**
* | output |
* | --- |
* | "Active" |
*
* @param {Tables_Skill_Groups_Is_ActiveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_skill_groups_is_active = /** @type {((inputs?: Tables_Skill_Groups_Is_ActiveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Skill_Groups_Is_ActiveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_skill_groups_is_active(inputs)
	return de_tables_skill_groups_is_active(inputs)
});